import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <>
      <div className="flex flex-col my-7 items-center justify-center max-w-[1000px] sm:mx-auto mx-4 h-[50svh] !text-center">
        <article className="flex flex-col items-start justify-start">
          <div className="mb-8">
            <h2 className="text-[#e9e9e9] text-bold leading-none xs:text-[220px] text-[180px]">
              404
            </h2>
            <p className="text-[1.65rem] text-[#5f5f5f]">
              عذرا، الصفحة التي تبحث عنها غير موجودة
            </p>
          </div>
          <Link
            to="/"
            className="flex but but--medium bg-[#004D5A] hover:bg-[#003E4A] items-center gap-x-4 self-center"
          >
            <p className="text-secondary-25 text-medium text-[18px]">
              عودة للرئيسية
            </p>
            <img
              src="/images/arrow-down-primary.svg"
              alt="back"
              className="-rotate-90"
            />
          </Link>
        </article>
      </div>
    </>
  );
};

export default NotFound;
